import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

interface EndgameSectionProps {
  value: any;
  onChange: (value: any) => void;
}

export const EndgameSection: React.FC<EndgameSectionProps> = ({ value, onChange }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <motion.div className="glass p-6 mb-4" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 20 }}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between mb-4"
      >
        <h2 className="subsection-title mb-0">Endgame</h2>
        <ChevronDown className={`w-5 h-5 transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <>
          <div className="mb-4">
            <label className="form-label">Tower Level</label>
            <select value={value.endgame_tower_level} onChange={(e) => onChange({ ...value, endgame_tower_level: e.target.value })} className="form-input">
              <option value="None">None</option>
              <option value="Level 1">Level 1 (10 pts)</option>
              <option value="Level 2">Level 2 (20 pts)</option>
              <option value="Level 3">Level 3 (30 pts)</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="form-label">Endgame Success</label>
            <button
              type="button"
              onClick={() => onChange({ ...value, endgame_success: !value.endgame_success })}
              className={`w-full py-2 rounded-lg font-medium transition-all ${
                value.endgame_success ? 'bg-green-600/30 border border-green-500/50 text-green-300' :
                'bg-gray-700/30 border border-gray-600/50 text-gray-400'
              }`}
            >
              {value.endgame_success ? '✓ Successful' : '✗ Failed'}
            </button>
          </div>

          <div>
            <label className="form-label">Time (seconds)</label>
            <input
              type="number"
              max="30"
              value={value.endgame_time_seconds}
              onChange={(e) => onChange({ ...value, endgame_time_seconds: Math.min(30, parseInt(e.target.value) || 0) })}
              className="form-input"
            />
          </div>
        </>
      )}
    </motion.div>
  );
};
